export const enum Tags {
    Account = 'account',
    AccountLogos = 'accountLogos',
    AccountsTotalBalance = 'accountsTotalBalance',
    BulkUploadSession = 'bulkUploadSession',
    BulkUploadSessionRows = 'bulkUploadSessionRows',
    Category = 'category',
    StatisticModel = 'statisticModel',
}